import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-data-list-overview',
    templateUrl: './data-list-overview.component.html',
    styleUrls: ['./data-list-overview.component.scss'],
    standalone: false
})
export class DataListOverviewComponent {
  @Input() data;
  @Input() title;
}
